export default {
  'sendverificationsms.sendverificationsms': 'طلب رمز التحقق',
  'sendverificationsms.maintext':
    'بالنقر فوق زر إرسال رسالة نصية، ستتلقى رسالة على هاتفك المسجل تحتوي على رمز تحقق يسمح لك بالتسجيل',
  'sendverificationsms.sendsms': 'الرجاء إرسال رسالة نصية لي',
};
